import ReactDOM from "react-dom/client"

const container = document.getElementById("root")
if (container === null) {
	throw new Error("Root container not found")
}

const root = ReactDOM.createRoot(container)
export default root
